/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8eae8472566d978eae59966a52abe97>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { OpsgenieLogo } from './logo';
export { OpsgenieLogoCS } from './logo-cs';
export { OpsgenieIcon } from './icon';
